import View from 'cdna/core/view';
import NavItemView from './navItemView.js';
import ContactView from './contactView.js';  

import style from './helpCenter.less';
import markup from './helpCenterView.html';

export default View.extend({
    el: markup,
    bindings: {
        'canPrint .btn[data-role=print]': 'visibility',
        'pages ul.nav': 'collection navBinding navBinder',
        'pages': 'collection pageBinding pageBinder'
    },
    navBinding: {
        itemView: NavItemView
    },
    pageBinding: {
        create: function(pageModel) {
            var pageType = pageModel.get('type');
            var type = this.registry[pageType];
            return new type.view({ model: pageModel }).render();
        },
        filter: function(pageModel) {
            return pageModel.get('isActive')
        }
    },
    events: {
        'click [data-role=print]': 'print',
        'click [data-role=contact]': 'showContactModal'
    },
    initialize(options, registry) {
        this.registry = registry;
    },
    print() {
        window.print();
    },
    showContactModal() {    
        var contact = new ContactView().render();
    }
});



/** WEBPACK FOOTER **
 ** ./client/helpCenterView.js
 **/